"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Question = function Question(props) {
  return _react2.default.createElement(
    "div",
    { className: "question" },
    _react2.default.createElement(
      "div",
      { className: "question-container" },
      _react2.default.createElement(
        "h3",
        null,
        props.questionTitle
      )
    )
  );
}; // import _ from 'lodash'
// import React, { Component } from 'react'
exports.default = Question;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/questionnaire/Question.js
 ** module id = 815
 ** module chunks = 0
 **/